import {
  CalendarCheck,
  FileText,
  LayoutDashboard,
  MapPin,
  Monitor,
  Package,
  ShieldCheck,
  Truck,
  Users,
} from 'lucide-react';
import type { TFunction } from 'i18next';
import type { AppShellNavItem } from '@ooh/ui/components/app-shell-layout';

export interface NavAccess {
  isAdmin: boolean;
  offers: boolean;
  clients: boolean;
  suppliers: boolean;
  reservations: boolean;
}

interface BuildNavEntriesOptions {
  includeDraftEntries?: boolean;
}

function gated(
  access: boolean,
  t: TFunction,
): Pick<AppShellNavItem, 'disabled' | 'disabledTooltip'> {
  return access ? {} : { disabled: true, disabledTooltip: t('nav.noAccess') };
}

export function buildNavEntries(
  t: TFunction,
  access: NavAccess,
  { includeDraftEntries = false }: BuildNavEntriesOptions = {},
): AppShellNavItem[] {
  const entries: AppShellNavItem[] = [
    {
      label: t('nav.dashboard'),
      icon: LayoutDashboard,
      path: '/dashboard',
      disabled: true,
      disabledTooltip: t('nav.comingSoon'),
    },
    { label: t('nav.mediaUnits'), icon: Monitor, path: '/media-units' },
    { label: t('nav.map'), icon: MapPin, path: '/map' },
  ];

  if (includeDraftEntries) {
    entries.push({
      label: t('nav.packages'),
      icon: Package,
      path: '/packages',
      badge: t('nav.draft'),
    });
  }

  entries.push(
    { label: t('nav.offers'), icon: FileText, path: '/offers', ...gated(access.offers, t) },
    { label: t('nav.clients'), icon: Users, path: '/clients', ...gated(access.clients, t) },
    { label: t('nav.suppliers'), icon: Truck, path: '/suppliers', ...gated(access.suppliers, t) },
    {
      label: t('nav.reservations'),
      icon: CalendarCheck,
      path: '/reservations',
      ...gated(access.reservations, t),
    },
  );

  if (access.isAdmin) {
    entries.push({ label: t('nav.admin'), icon: ShieldCheck, path: '/admin' });
  }

  return entries;
}
